import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './ResourcePage.css';

function Settings() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const [settings, setSettings] = useState({
    clusterName: 'my-cluster',
    defaultNamespace: 'default',
    refreshInterval: '30',
    theme: 'light',
  });

  const handleSave = (e) => {
    e.preventDefault();
    console.log('Saving settings:', settings);
    alert('Settings saved successfully!');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="resource-page">
      <div className="page-header">
        <h1>Settings</h1>
      </div>

      <div className="resource-list" style={{ padding: '24px' }}>
        <form onSubmit={handleSave}>
          <h3 style={{ marginTop: 0, marginBottom: '20px' }}>General Settings</h3>

          <div className="form-group">
            <label>Cluster Name</label>
            <input
              type="text"
              value={settings.clusterName}
              onChange={(e) => setSettings({ ...settings, clusterName: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Default Namespace</label>
            <select
              value={settings.defaultNamespace}
              onChange={(e) => setSettings({ ...settings, defaultNamespace: e.target.value })}
            >
              <option value="default">default</option>
              <option value="kube-system">kube-system</option>
              <option value="kube-public">kube-public</option>
            </select>
          </div>

          <div className="form-group">
            <label>Auto-refresh Interval (seconds)</label>
            <input
              type="number"
              value={settings.refreshInterval}
              onChange={(e) => setSettings({ ...settings, refreshInterval: e.target.value })}
              min="5"
              max="300"
            />
          </div>

          <div className="form-group">
            <label>Theme</label>
            <select
              value={settings.theme}
              onChange={(e) => setSettings({ ...settings, theme: e.target.value })}
            >
              <option value="light">Light</option>
              <option value="dark">Dark</option>
            </select>
          </div>

          <div style={{ marginTop: '24px', display: 'flex', gap: '10px' }}>
            <button type="submit" className="button-primary">
              Save Settings
            </button>
            <button type="button" className="button-danger" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </form>

        <div style={{ marginTop: '40px', paddingTop: '24px', borderTop: '1px solid var(--border)' }}>
          <h3>About</h3>
          <div className="info-card">
            <h3>SarvKube</h3>
            <p>Version: 1.0.0</p>
            <p>Kubernetes Cluster Management Platform</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
